export default __webpack_public_path__ + "static/accessingData-807b9dd6363d9d02d6bf6ee5527f6f49.gif";